import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import moment from "moment";
import Select, { components } from "react-select";
import './PackageForm.css';

const PackageItinerary = ({ packageId }) => {
  const initialFieldValues = {
    packageItineraryId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    hotelBookingId: "00000000-0000-0000-0000-000000000000",
    title: "",
    date: "",
    location: "",
    description: "",
    meals: "Breakfast",
    note: "",
  };
  const { user } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [isFormVisible, setIsFormVisible] = useState(false);
  const mealOptions = [
    { value: "Breakfast", label: "Breakfast" },
    { value: "Lunch", label: "Lunch" },
    { value: "Dinner", label: "Dinner" },
    { value: "Snacks", label: "Snacks" }
  ];
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddNewClick = () => {
    resetForm();
    setIsFormVisible(true);
  };

  const showEditDetails = (data) => {
    const formattedData = {
      ...data,
      date: moment(data.date).format('YYYY-MM-DDTHH:mm'),
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setIsFormVisible(true);
  };

  const GetData = async () => {
    try {
      const res = await apiService.get(`${config.GETITINERARYBYPACKAGEID}/${packageId}`);
      setLists(res.data);
    } catch (error) {
      console.error("Failed to fetch itinerary data:", error);
    }
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEITINERARY, itemToDelete);
        await GetData();
      } catch (error) {
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.title = values.title.trim() === "" ? false : true;
    temp.location = values.location.trim() === "" ? false : true;
     temp.description = values.description !== "";
      temp.date = values.date !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const formData = { ...values, packageId, userId: user?.id };
      try {
        const isNew = formData.packageItineraryId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEITINERARY, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEITINERARY, formData);
        }
        await GetData();
        handleCancel();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleCancel = () => {
    resetForm();
    setIsFormVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setRecordForEdit(null);
    setBtnLoading(false);
    setErrors({});
  };

  const applyErrorClass = (field) => (field in errors && errors[field] === false ? " form-control-danger" : "");

  useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);
  return (
    <div className="PackageItinerary-wrapper">
      <div className="card PackageItinerary-card">
        <div className="card-body">
          <div className="PackageItinerary-header">
            <h4 className="header-title">Day-by-Day Itinerary</h4>
            {!isFormVisible && (
              <button
                type="button"
                className="btn btn-primary PackageItinerary-btn-gradient"
                onClick={handleAddNewClick}
              >
                <i className="ri-add-line me-1"></i> Add Day
              </button>
            )}
          </div>

          {isFormVisible && (
            <div className="PackageItinerary-form-container">
              <h5 className="form-title">
                {values.packageItineraryId === "00000000-0000-0000-0000-000000000000"
                  ? "Add Itinerary Day"
                  : "Edit Itinerary Day"}
              </h5>
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                   <div className="col-lg-6 mb-3">
                    <label className="form-label d-flex align-items-center"><i className="ri-flag-line me-2"></i>Title*</label>
                    <input type="text" name="title" value={values.title} onChange={handleInputChange} className={`form-control ${applyErrorClass("title")}`} placeholder="Visit Burj Khalifa" />
                    {errors.title === false && <div className="invalid-feedback d-block">Please enter a title.</div>}
                  </div>
                   <div className="col-lg-6 mb-3">
                    <label className="form-label d-flex align-items-center"><i className="ri-map-pin-line me-2"></i>Location*</label>
                    <input type="text" name="location" value={values.location} onChange={handleInputChange} className={`form-control ${applyErrorClass("location")}`} placeholder="Dubai" />
                    {errors.location === false && <div className="invalid-feedback d-block">Please enter a location.</div>}
                  </div>

                  <div className="col-lg-12 mb-3">
                    <label className="form-label d-flex align-items-center"><i className="ri-file-text-line me-2"></i>Description</label>
                    <textarea name="description" value={values.description} onChange={handleInputChange} className={"form-control " + applyErrorClass("description")} placeholder="Describe the day's activities..." rows="3"></textarea>
                     {errors.description === false && <div className="invalid-feedback d-block">Please enter a description.</div>}
                  </div>
                  <div className="col-lg-3 mb-3">
                    <label className="form-label d-flex align-items-center"><i className="ri-calendar-event-line me-2"></i>Date</label>
                    <input type="date" name="date" value={values.date} onChange={handleInputChange} className={"form-control" + applyErrorClass("date")} />
                    {errors.date === false && <div className="invalid-feedback d-block">Please select a date.</div>}
                  </div>
                  <div className="col-lg-6 mb-3">
                    <label className="form-label d-flex align-items-center">
                      <i className="ri-restaurant-2-line me-2"></i>Meals
                    </label>
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ Option }}
                      options={mealOptions}
                      value={mealOptions.filter((option) =>
                        values.meals?.split(",").includes(option.value)   // convert stored string back to array
                      )}
                      onChange={(selected) =>
                        setValues({
                          ...values,
                          meals: selected.map((opt) => opt.value).join(","),  // save as comma-separated string
                        })
                      }
                      placeholder="Select Meals"
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <label className="form-label d-flex align-items-center"><i className="ri-sticky-note-line me-2"></i>Notes</label>
                    <textarea name="note" value={values.note} onChange={handleInputChange} className="form-control" placeholder="Add any extra notes or tips..." rows="3"></textarea>
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2">
                  <button type="button" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={btnLoading}>
                    {btnLoading ? "Saving..." : (values.packageItineraryId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update")}
                  </button>
                </div>
              </form>
            </div>
          )}

          <div className="mt-4">
            {lists.length > 0 ? (
              <div className="PackageItinerary-list">
                {lists.map((v) => (
                  <div key={v.packageItineraryId} className="PackageItinerary-list-item">
                    <div className="PackageItinerary-item-icon">
                      <i className="ri-route-line"></i>
                    </div>
                    <div className="PackageItinerary-item-content">
                      <div className="PackageItinerary-item-header">
                        <h6 className="PackageItinerary-item-title">{v.title}</h6>
                        <div className="PackageItinerary-item-meta">
                          <i className="ri-calendar-todo-line"></i>
                          {moment(v.date).format("ddd, DD MMM YYYY")}
                        </div>
                      </div>
                      <p className="PackageItinerary-item-description">{v.description}</p>
                      <div className="PackageItinerary-item-footer">
                        <div className="PackageItinerary-item-location">
                          <i className="ri-map-pin-2-fill"></i>
                          {v.location}
                        </div>
                        {v.meals && (
                          <div className="PackageItinerary-item-meals">
                            <i className="ri-restaurant-2-line"></i>
                            {v.meals.split(",").join(", ")}

                          </div>
                        )}
                      </div>
                      {v.note && (
                        <div className="PackageItinerary-item-note">
                          <i className="ri-information-line"></i> {v.note}
                        </div>
                      )}
                    </div>
                    <div className="PackageItinerary-item-actions">
                      <button className="PackageItinerary-action-btn edit" onClick={() => showEditDetails(v)}><i className="ri-pencil-fill" /></button>
                      <button className="PackageItinerary-action-btn delete" onClick={() => handleOpenDeleteModal(v.packageItineraryId)}><i className="ri-delete-bin-fill" /></button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="PackageItinerary-empty-state">
                <i className="ri-map-2-line empty-icon"></i>
                <h5>Your Itinerary is Empty</h5>
                <p>Start building the journey by adding the first day's plan.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
    </div>
  );
};

export default PackageItinerary;